import React from 'react';
import { FormattedMessage } from 'react-intl';

import LoginContainer from 'login/LoginContainer';
import ExternalAuth from 'login/ExternalAuth';
import ProfilesContainer from 'profiles/ProfilesContainer';
import AddProfileContainer from 'add-profile/AddProfileContainer';
import RegisterContainer from 'register/RegisterContainer';
import ClassesStudentsContainer from 'classes-students/ClassesStudentsContainer';
import ControlPanelContainer from 'control-panel/ControlPanelContainer';
import ConfigurationContainer from 'configuration/ConfigurationContainer';
import ReportsContainer from 'reports/ReportsContainer';
import ReportGeneralPanelContainer from 'reports/general-panel/ReportGeneralPanelContainer';
import ReportApplicationContainer from 'reports/application/ReportApplicationContainer';
import ReportGeneralPanelTRIContainer from 'reports/general-panel-tri/ReportGeneralPanelTRIContainer';
import NetworkPanelContainer from 'reports/network-panel/NetworkPanelContainer';
import ManagerDashboardRedirect from 'reports/network-panel/ManagerDashboardRedirect';
import ReportApplicationDetailsContainer from 'reports/application-detail/ReportApplicationDetailsContainer';
import SimulatedContainer from 'simulated/SimulatedContainer';
import StudentSimulatedContainer from 'student-simulated/StudentSimulatedContainer';
import SimulatedEditionContainer from 'simulated/simulated-edition/SimulatedEditionContainer';
import SimulatedContentMapContainer from 'simulated/content-map/SimulatedContentMapContainer';
import SimulatedCorrectionContainer from 'simulated/correction/SimulatedCorrectionContainer';
import ComposingCorrectionContainer from 'simulated/composing-correction/ComposingCorrectionContainer';
import SimulatedQuestionsContainer from 'simulated/questions/SimulatedQuestionsContainer';
import EditClassContainer from 'classes-students/edit/EditClassContainer';
// import UnitsContainer from 'units/UnitsContainer';
import ChangePassword from 'changePassword/ChangePasswordContainer';
import StudentSimulatedReportContainer from 'student-simulated/studentSimulatedReport';

import OnlineSimulatedContainer from 'online-simulated/OnlineSimulatedContainer';
import SimulatedEvaluationContainer from 'online-simulated/simulated-evaluation/SimulatedEvaluationContainer';

import AppContainer from './AppContainer';

import messages from './appMessages';

const isProd = process.env.SM_ENV === 'production';

/** Painel executivo (`/reports/network-panel`).
 * Acesso direto para Coordenador de escola (`permission === 1`) e Coordenador de Rede (`permission === 2`),
 * sem depender de `showReports` / habilitação prévia de contrato. */
export const canAccessManagerDashboard = ({ userType, coordinatorPermission }) =>
  userType != null &&
  Number(userType) !== 4 &&
  [1, 2].includes(Number(coordinatorPermission));

export const loginRoutes = [
  {
    path: '/login',
    exact: true,
    component: LoginContainer,
  },
  {
    path: '/auth',
    component: ExternalAuth,
  },
  {
    path: '/register',
    exact: true,
    component: RegisterContainer,
  },
  {
    path: '/change-password',
    exact: true,
    component: ChangePassword,
  },
];

export const appRoutes = [
  {
    path: '/',
    component: AppContainer,
    routes: [
      {
        path: '/online-simulated',
        exact: true,
        component: OnlineSimulatedContainer,
        sidebar: {
          active: (location) => /^\/online-simulated/.test(location.pathname),
          label: <FormattedMessage {...messages.sidebarOnlineSimulated} />,
          icon: <i className="pe-7s-note" />,
        },
        show: ({ userType }) => userType === 4,
        allow: ({ userType }) => userType === 4,
        expanded: true,
      },
      {
        path: '/online-simulated/:idEvaluation',
        exact: true,
        component: SimulatedEvaluationContainer,
        expanded: false,
      },
      {
        path: '/student-simulated',
        exact: true,
        component: StudentSimulatedContainer,
        sidebar: {
          active: (location) => /^\/student-simulated/.test(location.pathname),
          label: <FormattedMessage {...messages.sidebarReportCard} />,
          icon: <i className="pe-7s-note" />,
        },
        show: ({ userType }) => userType === 4,
        allow: ({ userType }) => userType === 4,
        // show: ({ userType }) => userType === 4 && false,
        // allow: ({ userType }) => userType === 4 && false,
        expanded: true,
      },
      {
        path: '/student-simulated/:idEvaluation',
        exact: true,
        component: StudentSimulatedReportContainer,
        allow: ({ userType }) => userType === 4,
        // allow: ({ userType }) => userType === 4 && false,
        expanded: true,
      },
      {
        path: '/simulated',
        exact: true,
        component: SimulatedContainer,
        sidebar: {
          active: (location) => /^\/simulated/.test(location.pathname),
          label: <FormattedMessage {...messages.sidebarSimulated} />,
          icon: <i className="pe-7s-note" />,
        },
        show: ({ userType }) => userType !== 4,
        allow: ({ userType }) => userType !== 4,
        expanded: true,
      },
      {
        path: '/simulated/:idEvaluation',
        exact: true,
        component: SimulatedEditionContainer,
        allow: ({ userType }) => userType !== 4,
        expanded: true,
      },
      {
        path: '/simulated/:idEvaluation/contentmap',
        component: SimulatedContentMapContainer,
        allow: ({ userType }) => userType !== 4,
        expanded: true,
      },
      {
        path: '/simulated/:idEvaluation/correction',
        component: SimulatedCorrectionContainer,
        allow: ({ userType }) => userType !== 4,
        expanded: true,
      },
      {
        path: '/simulated/:idEvaluation/composing-correction',
        component: ComposingCorrectionContainer,
        allow: ({ userType }) => userType !== 4,
        expanded: true,
      },
      {
        path: '/simulated/:idEvaluation/questions',
        exact: true,
        expanded: true,
        component: SimulatedQuestionsContainer,
        allow: ({ userType }) => userType !== 4,
        expanded: true,
      },
      {
        path: '/simulated/:idEvaluation/questions/:idQuestion',
        exact: true,
        expanded: true,
        component: SimulatedQuestionsContainer,
        allow: ({ userType }) => userType !== 4,
        expanded: true,
      },
      {
        path: '/control-panel',
        component: ControlPanelContainer,
        sidebar: {
          label: <FormattedMessage {...messages.sidebarControlPanel} />,
          icon: <i className="pe-7s-display2" />,
          badge: ({ logsNotRead }) =>
            logsNotRead > 0 ? <div className="sidebar-badge warning">{logsNotRead}</div> : null,
        },
        show: ({ userType }) => userType !== 4,
        allow: ({ userType }) => userType !== 4,
        expanded: true,
      },
      {
        path: '/settings',
        component: ConfigurationContainer,
        sidebar: {
          label: <FormattedMessage {...messages.sidebarConfiguration} />,
          icon: <i className="pe-7s-display2" />,
        },
        show: ({ userType }) => userType !== 4,
        // allow: ({ userType }) => userType !== 4,
        allow: ({ userType }) => userType,
        expanded: true,
      },

      // {
      //   path: '/units',
      //   component: UnitsContainer,
      //   sidebar: {
      //     label: <FormattedMessage {...messages.sidebarUnits} />,
      //     icon: <i className="pe-7s-pin" />,
      //   },
      // },
      {
        path: '/profiles',
        component: ProfilesContainer,
        exact: true,
        sidebar: {
          label: <FormattedMessage {...messages.sidebarProfiles} />,
          icon: <i className="pe-7s-user" />,
        },
        show: ({ coordinator, userType, canEditSchool }) =>
          coordinator && userType !== 4 && canEditSchool,
        allow: ({ coordinator, userType }) => coordinator && userType !== 4,
        expanded: true,
      },
      {
        path: '/profiles/add',
        component: AddProfileContainer,
        exact: true,
        show: ({ coordinator, userType }) => coordinator && userType !== 4,
        allow: ({ coordinator, userType }) => coordinator && userType !== 4,
        expanded: true,
      },
      {
        path: '/profiles/:idProfile',
        component: AddProfileContainer,
        exact: true,
        show: ({ coordinator, userType }) => coordinator && userType !== 4,
        allow: ({ coordinator, userType }) => coordinator && userType !== 4,
        expanded: true,
      },
      {
        path: '/groups',
        component: ClassesStudentsContainer,
        exact: true,
        sidebar: {
          active: (location) => /^\/groups/.test(location.pathname),
          label: <FormattedMessage {...messages.sidebarClassesStudents} />,
          icon: <i className="pe-7s-study" />,
        },
        show: ({ userType }) => userType !== 4,
        allow: ({ userType }) => userType !== 4,
        expanded: true,
      },
      {
        path: '/groups/:idESCourse',
        component: EditClassContainer,
        allow: ({ userType }) => userType !== 4,
        expanded: true,
      },
      {
        path: '/reports',
        component: ReportsContainer,
        exact: true,
        show: ({ userType }) => userType !== 4,
        allow: ({ userType }) => userType !== 4,
        sidebar: {
          active: (location) => /^\/reports/.test(location.pathname),
          label: <FormattedMessage {...messages.sidebarReports} />,
          icon: <i className="pe-7s-graph1" />,
        },
        childRoutes: [
          {
            path: '/reports/general',
            active: (location) => /^\/reports\/general/.test(location.pathname),
            label: <FormattedMessage {...messages.sidebarGeneralPanel} />,
            show: ({ showReports, userType }) => showReports && userType !== 4,
            allow: ({ showReports, userType }) => showReports && userType !== 4,
          },
          {
            path: '/reports/application',
            active: (location) => /^\/reports\/application/.test(location.pathname),
            label: <FormattedMessage {...messages.applications} />,
            show: ({ showReports, userType, hasEvaluationWithEssay }) =>
              (showReports || hasEvaluationWithEssay) && userType !== 4,
            allow: ({ showReports, userType, hasEvaluationWithEssay }) =>
              (showReports || hasEvaluationWithEssay) && userType !== 4,
          },
          {
            path: '/reports/network-panel',
            active: (location) => /^\/reports\/network-panel/.test(location.pathname),
            label: <FormattedMessage {...messages.sidebarNetworkPanel} />,
            show: (ctx) => canAccessManagerDashboard(ctx),
            allow: (ctx) => canAccessManagerDashboard(ctx),
          },
          {
            path: '/reports/gptri',
            active: (location) => /^\/reports\/gptri/.test(location.pathname),
            label: <FormattedMessage {...messages.generalPanelTRI} />,
            show: ({ showReportsTRI, userType }) => showReportsTRI && userType !== 4,
            allow: ({ showReportsTRI, userType }) => showReportsTRI && userType !== 4,
          },
          {
            path: '/reports/manager-dashboard',
            active: (location) => /^\/reports\/manager-dashboard/.test(location.pathname),
            label: <FormattedMessage {...messages.managerDashboard} />,
            show: () => false,
            allow: (ctx) => canAccessManagerDashboard(ctx),
          },
        ],
        expanded: true,
      },
      {
        path: '/reports/general',
        component: ReportGeneralPanelContainer,
        exact: true,
        active: (location) => /^\/reports\/general/.test(location.pathname),
        label: <FormattedMessage {...messages.sidebarGeneralPanel} />,
        show: ({ showReports, userType }) => showReports && userType !== 4,
        allow: ({ showReports, userType }) => showReports && userType !== 4,
        expanded: true,
      },
      {
        path: '/reports/application',
        component: ReportApplicationContainer,
        exact: true,
        active: (location) => /^\/reports\/application/.test(location.pathname),
        label: <FormattedMessage {...messages.applications} />,
        show: ({ showReports, userType, hasEvaluationWithEssay }) =>
          (showReports || hasEvaluationWithEssay) && userType !== 4,
        allow: ({ showReports, userType, hasEvaluationWithEssay }) =>
          (showReports || hasEvaluationWithEssay) && userType !== 4,
        expanded: true,
      },
      {
        path: '/reports/application/:idEvaluation',
        component: ReportApplicationDetailsContainer,
        active: (location) => /^\/reports\/application/.test(location.pathname),
        show: ({ showReports, userType, hasEvaluationWithEssay }) =>
          (showReports || hasEvaluationWithEssay) && userType !== 4,
        allow: ({ showReports, userType, hasEvaluationWithEssay }) =>
          (showReports || hasEvaluationWithEssay) && userType !== 4,
        expanded: true,
      },
      {
        path: '/reports/gptri',
        component: ReportGeneralPanelTRIContainer,
        exact: true,
        active: (location) => /^\/reports\/gptri/.test(location.pathname),
        show: ({ showReportsTRI, userType }) => showReportsTRI && userType !== 4,
        allow: ({ showReportsTRI, userType }) => showReportsTRI && userType !== 4,
        expanded: true,
      },
      {
        path: '/reports/network-panel',
        component: NetworkPanelContainer,
        exact: true,
        active: (location) => /^\/reports\/network-panel/.test(location.pathname),
        show: (ctx) => canAccessManagerDashboard(ctx),
        allow: (ctx) => canAccessManagerDashboard(ctx),
        expanded: true,
      },
      {
        path: '/reports/manager-dashboard',
        component: ManagerDashboardRedirect,
        exact: true,
        active: (location) => /^\/reports\/manager-dashboard/.test(location.pathname),
        show: () => false,
        allow: (ctx) => canAccessManagerDashboard(ctx),
        expanded: true,
      },
    ],
  },
];

export default appRoutes;
